import { Outlet, Navigate } from "react-router-dom";

import { AuthHelper } from "../helpers/auth.helper";

export const AuthRoutes = () => {
    const isAuthTokenValid = AuthHelper.isAuthTokenValid().result;
    const isGuestTokenValid = AuthHelper.isGuestTokenValid().result;

    return (
        !isGuestTokenValid && !isAuthTokenValid
            ? <Outlet />
            : <Navigate to="/" />
    );
};